import React, { ReactElement } from "react";
import { AiOutlineCode, AiTwotoneQuestionCircle } from "react-icons/ai";
import { BiSupport } from "react-icons/bi";
import {
    BsFillPeopleFill, BsFillShieldFill, BsPersonBadge, BsPersonHearts, BsPlugin,
} from "react-icons/bs";
import { FaMoneyCheck, FaMoneyCheckAlt, FaRocket } from "react-icons/fa";
import { GoLaw } from "react-icons/go";
import { MdGolfCourse, MdOutlineAttachMoney } from "react-icons/md";
import { SiOnlyoffice } from "react-icons/si";
import { JobFunction } from "../../../__generated__/api";
import { StepProps } from "./base";
import Help, { ARTICLES } from "../../../components/help/Help";

const ROLES = [
    { icon: BiSupport, title: "Customer Support", jobFunction: JobFunction.CustomerSupport },
    { icon: BsPlugin, title: "Information Technology (IT)", jobFunction: JobFunction.InformationTechnology },
    { icon: BsFillPeopleFill, title: "Human Resources (HR)", jobFunction: JobFunction.HumanResources },
    { icon: BsFillShieldFill, title: "Security", jobFunction: JobFunction.Security },
    { icon: GoLaw, title: "Legal", jobFunction: JobFunction.Legal },
    { icon: AiOutlineCode, title: "Engineering", jobFunction: JobFunction.Engineering },
    { icon: FaMoneyCheckAlt, title: "Finance", jobFunction: JobFunction.Finance },
    { icon: MdGolfCourse, title: "Executive/Founder", jobFunction: JobFunction.Founder },
    { icon: SiOnlyoffice, title: "Partnerships", jobFunction: JobFunction.Partnerships },
    { icon: FaRocket, title: "Product", jobFunction: JobFunction.Product },
    { icon: FaMoneyCheck, title: "Revenue Operations", jobFunction: JobFunction.RevenueOperations },
    { icon: MdOutlineAttachMoney, title: "Sales", jobFunction: JobFunction.Sales },
    { icon: AiTwotoneQuestionCircle, title: "Other", jobFunction: JobFunction.Other },
];
export default function OnboardingStep(props: StepProps): ReactElement {
    const [isOther, setIsOther] = React.useState(
        props.profile.jobFunction === JobFunction.Other || props.profile.jobFunction === JobFunction.OtherInternal,
    );
    return (
        <div className="w-100">
            <h2 className="text-center">Welcome to Foqal</h2>
            <p>
                Welcome to Foqal Agent, to better let Foqal tailor your needs, we
                ask you just a few questions to help you get started. Don&apos;t worry
                you will be able to get back to all of these settings after you are done.
            </p>

            <Help title="What is your role?" articleId={ARTICLES.PICK_ROLE_PAGE} />
            {isOther ? (
                <div className="list-group">
                    <h4 className="mt-3 mb-3">Who do you mostly support</h4>
                    <div className="d-flex list-group flex-row w-100 gap-2">
                        <div className="text-center d-flex flex-column">
                            <button
                                onClick={() => props.onNext({ ...props.profile, jobFunction: JobFunction.Other })}
                                type="button"
                                className={`list-group-item list-group-item-action flex-grow-1 p-3 rounded ${
                                    props.profile.jobFunction === JobFunction.Other ? "bg-blue-light text-white" : ""}`}
                            >
                                <BsPersonHearts size="30px" className="d-block mx-auto mb-2 text-light" />
                                <strong>Customers or Partners</strong>
                                <p>
                                    You are mostly supporting external customers or partners.
                                </p>
                            </button>

                        </div>
                        <div className="text-center d-flex flex-column col-6">
                            <button
                                onClick={() => props.onNext({ ...props.profile, jobFunction: JobFunction.OtherInternal })}
                                type="button"
                                className={`list-group-item list-group-item-action flex-grow-1 p-3 rounded ${
                                    props.profile.jobFunction === JobFunction.OtherInternal ? "bg-blue-light text-white" : ""}`}
                            >
                                <BsPersonBadge size="30px" className="d-block mx-auto mb-2 text-light" />
                                <strong>Co-workers</strong>
                                <p>
                                    You are mostly supporting colleages or co-workers.
                                </p>
                            </button>

                        </div>

                    </div>
                    <div className="w-100 mt-2 text-center">
                        <button
                            type="button"
                            className="btn btn-link  text-light"
                            onClick={() => setIsOther(false)}
                        >
                            Select a different role
                        </button>
                    </div>

                </div>
            ) : (
                <div>
                    <h4 className="mt-3 mb-3">What is your role?</h4>
                    <ul className="list-group">
                        {ROLES.map(role => (
                            <button
                                type="button"
                                className={`list-group-item list-group-item-action ${
                                    props.profile.jobFunction === role.jobFunction ? " bg-blue-light text-white" : ""}`}
                                key={role.jobFunction}
                                onClick={() => {
                                    if (role.jobFunction === JobFunction.Other) {
                                        setIsOther(true);
                                    } else {
                                        props.onNext({ ...props.profile, jobFunction: role.jobFunction });
                                    }
                                }}
                            >
                                {role.icon && (
                                    <role.icon className="me-2 text-light" />
                                )}
                                {role.title}
                            </button>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
}
